import { DateTime } from 'luxon'
import { snakeCase } from 'lodash'

export const formatPastRange = (daysAgo: number): string => {
  const now = DateTime.now()
  const startDate = now.minus({ days: daysAgo }).toFormat('MMM dd')
  const endDate = now.toFormat('MMM dd')
  return `${startDate} - ${endDate}`
}

export const formatFutureRange = (
  daysAhead: number,
  endDateReturn?: boolean
): string => {
  const now = DateTime.now()
  const startDate = now.toFormat('MMM dd')
  const endDate = now.plus({ days: daysAhead }).toFormat('MMM dd')
  if (endDateReturn) {
    return endDate
  }
  return `${startDate} - ${endDate}`
}

export const formatPastDate = (daysAgo: number): string => {
  return DateTime.now().minus({ days: daysAgo }).toFormat('MMM dd')
}

export const convertToFullDateTime = (dateString: string): Date => {
  return DateTime.fromISO(dateString).toJSDate()
}

export const formatDateToISO = (date: Date): string => {
  return DateTime.fromJSDate(date).toISODate() ?? ''
}

export const convertObjectKeysAndValuesToCommaSeprated = <
  T extends Record<string, string>,
>(
  obj: T | null | undefined
): { keys: string | undefined; values: string | undefined } => {
  if (obj === null || typeof obj !== 'object' || Array.isArray(obj)) {
    return { keys: undefined, values: undefined }
  }

  const keys = Object.keys(obj).map(snakeCase).join(',')
  const values = Object.values(obj).join(',')

  return { keys, values }
}

export const formatToDecimalPlaces = (
  value: string | number | null | undefined,
  decimalPlaces = 2
): string => {
  if (value === null || value === undefined || value === '') {
    return '-'
  }
  const num = typeof value === 'number' ? value : parseFloat(value)
  if (Number.isNaN(num)) {
    return '-'
  }
  return num.toFixed(decimalPlaces)
}
